import { connect, mapProps } from '@formily/react'
import { InputNumber } from '../ui/input-number'
import { cn } from '@/lib/utils'

export const FormilyInputNumber = connect(
  InputNumber,
  mapProps((props) => ({
    ...props,
    className: cn(
      'border-[rgba(255,255,255,0.06)] focus-within:border-[rgba(255,255,255,0.2)]',
      props.className,
    ),
    value: props.value,
  })),
)
